import React from 'react';
import { MessageSquareCode } from 'lucide-react';

export default function WhatsAppButton() {
  const number = "919225836006"; // International country code prefix + 9225836006
  const text = encodeURIComponent("Hello Kiran Distributors! I am visiting your website and would like to inquire about medical supplies / hospital setup services.");
  const url = `https://wa.me/${number}?text=${text}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contact on WhatsApp"
      className="fixed bottom-6 right-6 z-[99] bg-[#25D366] text-white w-14 h-14 rounded-full shadow-2xl shadow-[#25D366]/30 flex items-center justify-center hover:scale-110 active:scale-95 transition-all duration-300 group border border-white/20"
    >
      {/* Outer ripple ring animation */}
      <span className="absolute -inset-1 rounded-full bg-[#25D366]/40 blur-sm opacity-70 animate-ping group-hover:animate-none" />
      
      {/* Icon */}
      <svg
        viewBox="0 0 24 24"
        className="w-6 h-6 fill-white text-white shrink-0 relative z-10"
      >
        <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.724-1.455L0 24zm6.59-4.846c1.665.988 3.3 1.49 4.805 1.491 5.494 0 9.961-4.438 9.964-9.88A9.886 9.886 0 0 0 12.008 2.04c-5.502 0-9.963 4.44-9.966 9.882-.001 1.81.499 3.579 1.45 5.118L2.4 21.57l4.247-1.416zm9.845-5.511c-.269-.134-1.594-.786-1.841-.875-.246-.09-.425-.134-.604.134-.18.269-.695.875-.853 1.054-.157.18-.314.202-.583.067-.27-.134-1.138-.419-2.167-1.338-.802-.716-1.343-1.6-1.5-1.869-.158-.269-.017-.415.118-.549.121-.12.269-.314.403-.471.135-.157.18-.269.27-.449.09-.18.045-.337-.023-.471-.067-.134-.604-1.456-.827-1.995-.218-.524-.457-.453-.604-.461-.157-.008-.337-.009-.517-.009-.18 0-.471.067-.718.337-.247.269-.942.92-1.077 2.243-.135 1.323.83 2.6 1.138 2.959.309.359 1.854 2.829 4.49 3.971.628.272 1.118.434 1.503.556.631.2 1.204.171 1.657.104.505-.075 1.594-.65 1.819-1.278.224-.628.224-1.166.157-1.278-.067-.113-.247-.18-.517-.313z" />
      </svg>
      
      {/* Dynamic text tool-tip */}
      <span className="absolute right-16 scale-0 group-hover:scale-100 bg-brand-navy text-white text-xs px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 font-poppins font-medium tracking-wider whitespace-nowrap shadow-lg">
        Chat with Expert
      </span>
    </a>
  );
}
